<template>
  <div class="lead-time-wrapper">
    <div v-if="getShipsInDate" :style="leadTimeStyle" class="product-lead-time">
      <img
        src="https://res.cloudinary.com/legrandav/image/upload/t_SnapOne Product /v1707253441/info_outline_small.jpg"
        alt="Information"
        class="material-icons"
      />
      <span :class="leadTimeMessage" v-html="displaymessage"></span>
    </div>

    <div v-else :style="leadTimeStyle" class="product-lead-time">
      <div class="chat-for-price-link">
        <a tabindex="0" @click="callChat" href="javascript:void(0)">
          <img
            src="https://res.cloudinary.com/avd/image/upload/v1633720630/Icons/New%20Design%20Site%20Icons/communication-chat_outline.svg"
            alt="NavigationActionLiveChat Icon"
          />
          <span :class="leadTimeMessage" class="chat-for-price-link-label">
            Chat for availability</span
          >
        </a>
      </div>
    </div>

    <div v-if="isbracket" class="option-required-product">
      <img class="errorIcon" :src="errorIconSrc" />
      <div class="non-icon-option-required-product-text">
        Requires: {{ MfProductcount }}
        <NBS />
        <a
          v-if="MfProductUrl"
          :href="MfProductUrl"
          :class="'required-product-link ' + analyticsClassRequiredProduct"
          target="_blank"
          rel="noopener noreferrer"
          v-bind="dataAttributeOptionRequiredProduct"
        >
          {{ qryvalue }}
        </a>
        <span v-else>
          {{ qryvalue }}
        </span>
        <NBS /> per
        {{ mfsku }}
      </div>
    </div>
  </div>
</template>
<script>
import ProductOptionService from "../../services/ProductOptionService";
import { mapGetters, mapActions } from "vuex";
import NBS from "../shared/NonBreakingSpace.vue";
export default {
  name: "ProductOptionsModal",
  props: {
    styleData: Array
  },
  data() {
    return {
      isbracket: false,
      MfProductcount: null,
      MfProductUrl: null,
      mfquerystring: null,
      mfsku: null,
      qryvalue: null,
      lastSkuCode: null
    };
  },
  watch: {
    "getProductSku.SkuCode": {
      handler(newSkuCode) {
        if (newSkuCode) {
          if (newSkuCode && !this.hasBasicSAPLeadTimeTriggered) {
            this.$store.dispatch("product/loadBasicSAPLeadTime", newSkuCode);
          }
        }
      },
      immediate: true
    }
  },
  created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const qrybracket = urlParams.get("bracket") ? urlParams.get("bracket") : "";

    if (qrybracket != "") {
      const [manufacturer, model] = qrybracket.split("|");
      this.qryvalue = qrybracket.toUpperCase();
      ProductOptionService.getMFnotes(
        manufacturer,
        model,
        this.getProductSku.SkuCode
      )
        .then(res => res.data)
        .then(products => {
          if (products.ProductUrl && products.RequiresProductCode) {
            this.MfProductUrl =
              products.ProductUrl != "#" ? products.ProductUrl : "";
            this.mfsku = products.ProductCode;
            this.MfProductcount = products.RequiresProductQuantity;
            this.qryvalue = products.RequiresProductCode;
            this.isbracket = true;
          } else {
            this.isbracket = false;
          }
        })
        .catch(() => {
          // to handle error
          this.MfProductUrl = null;
          this.mfsku = null;
          this.isbracket = false;
        });
    } else {
      return;
    }
  },
  computed: {
    ...mapGetters("product", [
      "getProductSku",
      "basicSAPLeadTime",
      "hasBasicSAPLeadTimeTriggered"
    ]),
    leadTimeInfo() {
      return this.basicSAPLeadTime;
    },
    errorIconSrc() {
      return "https://res.cloudinary.com/avd/image/upload/v1661964419/Icons/New%20Design%20Site%20Icons/error.svg";
    },
    leadTimeStyle() {
      return "border-color: #2E5276";
    },
    iconColor() {
      return "color: #2E5276";
    },
    leadTimeMessage() {
      const leadTime = parseInt(this.leadTimeInfo?.leadtime);
      if (
        leadTime === 99 || // 99 is for Don't know the availability, call availability
        leadTime === 98 || // 98 is for order through customer care
        leadTime === 86 || // 86 is for discontinued product
        leadTime === 0 // 0 is for something wrong
      ) {
        return "lead-time-message-primary";
      } else {
        return "lead-time-message-secondary";
      }
    },
    isIE() {
      return window.navigator.userAgent.indexOf("Trident/") > -1;
    },
    getShipsInDate() {
      const leadTime = parseInt(this.leadTimeInfo?.leadtime);
      if (
        this.leadTimeInfo?.deliverydate &&
        leadTime != 0 && // 99 is for Don't know the availability, call availability
        leadTime != 99 && // 98 is for order through customer care
        leadTime != 98 && // 86 is for discontinued product
        leadTime != 86 // 0 is for something wrong
      ) {
        let dayText = leadTime == 1 ? " Day - " : " Days - ";
        const dateObj = new Date(this.leadTimeInfo?.deliverydate);
        const date = new Date(dateObj);
        const day = date.getDate();
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getFullYear();
        const formattedDate = `${month} ${day}, ${year}`;
        return leadTime + dayText + formattedDate;
      } else {
        return "";
      }
    },
    displaymessage() {
      return `Typically ships in: <b>${this.getShipsInDate}</b>`;
    }
  },
  methods: {
    ...mapActions("product", ["loadBasicSAPLeadTime"]), // Map actions from the Vuex store
    callChat() {
      const salesForceChatEvent = new CustomEvent("loadsalesforcechat");
      document.body.dispatchEvent(salesForceChatEvent);
    }
  },
  components: { NBS },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.lead-time-wrapper {
  margin-bottom: 25px;
  border-bottom: 3px solid $gray-light;
  @include media-breakpoint-up(sm) {
    margin-bottom: 0;
    border-bottom: 0;
  }
}
.product-lead-time {
  display: flex;
  border-width: 1px 1px 1px 5px;
  margin: 0 0 24px 0;
  align-items: center;
  height: 50px;

  .customLeadTimeIcon {
    margin: 8px 0 0 0;
  }

  .material-icons {
    width: 20px;
    height: 20px;
    font-size: 24px;
    @include media-breakpoint-up(sm) {
      font-size: 28px;
    }
  }

  .lead-time-message-primary {
    color: $primary;
    font-family: $body;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.25px;
    line-height: 24px;
    padding: 0px 0 0 2px;
  }

  .lead-time-message-secondary {
    color: $primary;
    font-family: $body;
    font-size: 16px;
    letter-spacing: 0.25px;
    line-height: 24px;
    padding: 0px 0 0 5px;
  }
}

.option-required-product {
  @include hdg();
  @include body_small();
  display: flex;
  align-items: center;
  background-color: $warning-200;
  border: 1px solid $warning;
  min-height: 50px;
  padding-left: 16px;
  padding-right: 16px;
  min-width: 100%;
  @media (min-width: $lg-tablet) {
    min-width: 100%;
    max-width: max-content;
  }
}
// Shared link styles mixin
@mixin link-styles {
  color: $primary;

  &:hover,
  &:focus {
    color: $primary-300;
  }

  &:focus {
    @include focus_outline();
  }
}

.chat-for-price-link-label {
  @include link-styles;
}

.required-product-link {
  @include link-styles;
  text-decoration: underline;
}

.errorIcon {
  margin-right: 8px;
}
.non-icon-option-required-product-text {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 6px;
  margin-top: 6px;
  color: #262626;
}
.Mfnote-Padding {
  padding-bottom: 24px;
}
</style>
